import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import InfoCollapse from '../components/test/InfoCollapse';
import styles from '../styles/NavButton.module.css';

const Viajeros = () => {
  const { isDarkMode } = useTheme();
  const { isAuthenticated, student } = useAuth();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 6 && hour < 12) return 'Buenos días';
    if (hour >= 12 && hour < 20) return 'Buenas tardes';
    return 'Buenas noches';
  };

  return (
    <>
      <Header />

      {isAuthenticated ? (
        <div style={{
          textAlign: 'center',
          marginTop: '7rem',
          marginBottom: '2rem'
        }}>
          <h2 style={{
            fontSize: '1.5rem',
            marginBottom: '1rem'
          }}>
            {getGreeting()}, {student?.name}
          </h2>
          <h1 style={{
            borderBottom: `4px solid ${isDarkMode ? '#fff' : '#000'}`,
            paddingBottom: '0.5rem'
          }}>
            TESTS CAP VIAJEROS - PLAN PRO
          </h1>
          <p style={{
            marginTop: '1rem',
            color: '#4CAF50',
            fontWeight: 'bold'
          }}>
            Tests ilimitados hasta el fin de tu suscripción
          </p>
        </div>
      ) : (
        <h1 style={{
          textAlign: 'center',
          marginTop: '7rem',
          marginBottom: '2rem',
          borderBottom: `4px solid ${isDarkMode ? '#fff' : '#000'}`,
          paddingBottom: '0.5rem'
        }}>
          TESTS CAP VIAJEROS
        </h1>
      )}

      <div className="container">
        <InfoCollapse>
          <h2>Información del Examen</h2>
          <ul>
            <li>• 100 preguntas tipo test</li>
            <li>• Respuestas correctas: +1 punto</li>
            <li>• Respuestas incorrectas: -0.5 puntos</li>
            <li>• Respuestas en blanco: 0 puntos</li>
            <li>• Puntuación mínima para aprobar: 50 puntos</li>
          </ul>
        </InfoCollapse>

        <nav style={{
          marginBottom: 'clamp(3rem, 8vw, 5rem)'
        }}>
          <ul style={{ 
            listStyle: 'none', 
            padding: '0',
            display: 'grid',
            gap: '1rem'
          }}>
            <li>
              <Link 
                to="/test-aleatorio?type=viajeros" 
                className={`${styles.navButton} ${styles.testCompleto} ${isDarkMode ? styles.dark : ''}`}
              >
                <h3 className={styles.title}>Test Completo</h3>
                <p className={styles.description}>
                  100 preguntas aleatorias simulando el examen real
                </p>
              </Link>
            </li>
            <li>
              <Link 
                to="/test-practica?type=viajeros" 
                className={`${styles.navButton} ${styles.modoPractica} ${isDarkMode ? styles.dark : ''}`}
              >
                <h3 className={styles.title}>Modo Práctica</h3>
                <p className={styles.description}>
                  30 preguntas con corrección inmediata y explicaciones
                </p>
              </Link>
            </li>
            <li>
              <Link 
                to="/modulos?type=viajeros" 
                className={`${styles.navButton} ${styles.modulos} ${isDarkMode ? styles.dark : ''}`}
              >
                <h3 className={styles.title}>Practicar por Módulos</h3>
                <p className={styles.description}>
                  Estudia las preguntas organizadas por temas
                </p>
              </Link>
            </li>
            <li>
              <Link 
                to="/repaso?type=viajeros" 
                className={`${styles.navButton} ${styles.repaso} ${isDarkMode ? styles.dark : ''}`}
              >
                <h3 className={styles.title}>Repasar Fallos</h3>
                <p className={styles.description}>
                  Practica las preguntas que has fallado anteriormente
                </p>
              </Link>
            </li>
          </ul>
        </nav>
        <Footer />
      </div>
    </>
  );
};

export default Viajeros;